const utils = require('./xmlUtils') // to construct <SmartType> tag

// type arg === 'Extension' || 'Character' || 'Location' || 'TimeOfDay' || 'Transition'
function createSmartTypeTag (script, type, mode) {
  let listed
  switch (type.toLowerCase()) {
    case 'extension':
    case 'character':
      listed = utils.getCharactersAndExtensions(script, mode)[`${type.toLowerCase()}s`]
      break
    case 'location':
      listed = utils.getLocationsAndTimes(script, mode).locations
      break
    case 'timeofday':
      listed = utils.getLocationsAndTimes(script, mode).times
      break
    case 'transition':
      listed = utils.getTransitions(script, mode).transitions
      break
  }
  const formatted = type[0].toUpperCase() + type.substr(1)
  const result = listed.map(char => {
    return `<${formatted}>${char}</${formatted}>`
  }).join('\n')
  return result
}

function xmlBoilerplate (script, mode) {
  const isProse = mode === 'PROSE_TO_FDX'
  script = isProse ? utils.flattenScript(script) : script
  const xml = []
  xml.push('  </FinalDraft>') // THE END (tags are built in reverse)

  // tags added by FD
  xml.push(`  <DisplayBoards>
      <DisplayBoard Height="55" ScrollOrigin="0,0" Type="StoryMap" Width="2032" ZoomLevel="100.000"/>
      <DisplayBoard Height="10000" ScrollOrigin="0,0" Type="Beat" Width="24000" ZoomLevel="100.000"/>
    </DisplayBoards>`)

  xml.push('  <ListItems/>')
  xml.push('  <TargetScriptLength>120</TargetScriptLength>')
  xml.push('  <AltCollection/>')
  xml.push('  <CharacterNavigatorPreferences IsSortAscending="Yes" SortColumn="Order"/>')

  // TODO
  // xml.push(`  <CharacterHighlighting>
  //     <Character Color="#FFFFFFFFFFFF" Name="AUBREY" Visible="No"/>
  //   </CharacterHighlighting>`)

  xml.push(`  <CastList SortOption="Alphabetical">
      <CustomOrder/>
    </CastList>`)

  xml.push(`  <SceneNumberOptions LeftLocation="0.75" NumberScheme="1A" RightLocation="7.38" ShowNumbersOnLeft="Yes" ShowNumbersOnRight="Yes">
      <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
    </SceneNumberOptions>`)

  // TODO
  // xml.push(`  <Cast>
  //     <Narrator Actor="Man 1">
  //       <Element Type="Character"/>
  //       <Element Type="Dialogue"/>
  //     </Narrator>
  //     <Member Actor="" Character="AUBREY"/>
  //     <Member Actor="" Character="RUSTY"/>
  //   </Cast>`)

  xml.push(`  <Actors>
      <Actor MacVoice="" Name="Man 1" Pitch="Normal" Speed="Medium" WinVoice=""/>
      <Actor MacVoice="" Name="Man 2" Pitch="Normal" Speed="Medium" WinVoice=""/>
      <Actor MacVoice="" Name="Woman 1" Pitch="Normal" Speed="Medium" WinVoice=""/>
      <Actor MacVoice="" Name="Woman 2" Pitch="Normal" Speed="Medium" WinVoice=""/>
      <Actor MacVoice="" Name="Boy 1" Pitch="Normal" Speed="Medium" WinVoice=""/>
      <Actor MacVoice="" Name="Boy 2" Pitch="Normal" Speed="Medium" WinVoice=""/>
      <Actor MacVoice="" Name="Girl 1" Pitch="Normal" Speed="Medium" WinVoice=""/>
      <Actor MacVoice="" Name="Girl 2" Pitch="Normal" Speed="Medium" WinVoice=""/>
      <Actor MacVoice="" Name="Old Man" Pitch="Normal" Speed="Medium" WinVoice=""/>
      <Actor MacVoice="" Name="Old Woman" Pitch="Normal" Speed="Medium" WinVoice=""/>
    </Actors>`)

  xml.push(`<Macros>
      <Macro Element="Scene Heading" Name="INT" Shortcut="Ctrl+Alt+1" Text="INT. " Transition="None">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Scene Heading" Name="EXT" Shortcut="Ctrl+Alt+2" Text="EXT. " Transition="None">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Scene Heading" Name="I/E" Shortcut="Ctrl+Alt+3" Text="I/E " Transition="None">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Scene Heading" Name="DAY" Shortcut="Ctrl+Alt+4" Text=" - DAY" Transition="Action">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Scene Heading" Name="NIGHT" Shortcut="Ctrl+Alt+5" Text=" - NIGHT" Transition="Action">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Scene Heading" Name="SUNRISE" Shortcut="Ctrl+Alt+6" Text=" - SUNRISE" Transition="Action">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Scene Heading" Name="MAGIC" Shortcut="Ctrl+Alt+7" Text=" - MAGIC" Transition="Action">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Parenthetical" Name="CONT" Shortcut="Ctrl+Alt+8" Text="continuing" Transition="Dialogue">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Parenthetical" Name="INTER" Shortcut="Ctrl+Alt+9" Text="interrupting" Transition="Dialogue">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="None" Name="" Shortcut="Ctrl+Alt+0" Text="" Transition="None">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Transition" Name="CUTTO" Shortcut="Ctrl+Shift+Alt+1" Text="CUT TO:" Transition="Scene Heading">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Action" Name="FADEIN" Shortcut="Ctrl+Shift+Alt+2" Text="FADE IN:" Transition="Scene Heading">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Transition" Name="FADEOUT" Shortcut="Ctrl+Shift+Alt+3" Text="FADE OUT." Transition="Scene Heading">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Transition" Name="FADETO" Shortcut="Ctrl+Shift+Alt+4" Text="FADE TO:" Transition="Scene Heading">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Transition" Name="DISSLV" Shortcut="Ctrl+Shift+Alt+5" Text="DISSOLVE TO:" Transition="Scene Heading">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Transition" Name="BACKTO" Shortcut="Ctrl+Shift+Alt+6" Text="BACK TO:" Transition="Scene Heading">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Transition" Name="MATCHCUT" Shortcut="Ctrl+Shift+Alt+7" Text="MATCH CUT TO:" Transition="Scene Heading">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Transition" Name="JUMPCUT" Shortcut="Ctrl+Shift+Alt+8" Text="JUMP CUT TO:" Transition="Scene Heading">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="Transition" Name="FBLACK" Shortcut="Ctrl+Shift+Alt+9" Text="FADE TO BLACK." Transition="None">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
      <Macro Element="None" Name="" Shortcut="E" Text="" Transition="None">
        <Alias Confirm="No" MatchCase="No" SmartReplace="Yes" Text="" WordOnly="No">
          <ActivateIn Element="General"/>
          <ActivateIn Element="Scene Heading"/>
          <ActivateIn Element="Action"/>
          <ActivateIn Element="Character"/>
          <ActivateIn Element="Parenthetical"/>
          <ActivateIn Element="Dialogue"/>
          <ActivateIn Element="Transition"/>
          <ActivateIn Element="Shot"/>
        </Alias>
      </Macro>
    </Macros>`)

  xml.push(`  <SplitState ActivePanel="1" SplitMode="None" SplitterPosition="0">
      <ScriptPanel DisplayMode="Page">
        <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Verdana" RevisionID="0" Size="9" Style=""/>
      </ScriptPanel>
    </SplitState>`)

  // xml.push('<DeletedText></DeletedText>') this doesn't exist in the xml output unless we have the functionality (unlike LockedPages below)

  xml.push(`  <Revisions ActiveSet="1" Location="7.75" RevisionMode="No" RevisionsShown="Active" ShowAllMarks="No" ShowAllSets="No" ShowPageColor="No">
      <Revision Color="#000000000000" FullRevision="No" ID="1" Mark="*" Name="Blue Rev. (mm/dd/yy)" PageColor="#C6C6EDEDFEFE" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="2" Mark="*" Name="Pink Rev. (mm/dd/yy)" PageColor="#FDFDCCCCD4D4" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="3" Mark="*" Name="Yellow Rev. (mm/dd/yy)" PageColor="#FDFDFFFFABAB" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="4" Mark="*" Name="Green Rev. (mm/dd/yy)" PageColor="#D1D1FEFED0D0" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="5" Mark="*" Name="Goldenrod Rev. (mm/dd/yy)" PageColor="#FAFACDCD3939" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="6" Mark="*" Name="Buff Rev. (mm/dd/yy)" PageColor="#FCFCEDED9D9D" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="7" Mark="*" Name="Salmon Rev. (mm/dd/yy)" PageColor="#F8F8AEAE8E8E" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="8" Mark="*" Name="Cherry Rev. (mm/dd/yy)" PageColor="#FBFBA4A4B4B4" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="9" Mark="*" Name="Tan Rev. (mm/dd/yy)" PageColor="#FDFDF1F1C7C7" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="10" Mark="*" Name="2nd White Rev. (mm/dd/yy)" PageColor="#FFFFFFFFFFFF" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="11" Mark="*" Name="2nd Blue Rev. (mm/dd/yy)" PageColor="#C6C6EDEDFEFE" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="12" Mark="*" Name="2nd Pink Rev. (mm/dd/yy)" PageColor="#FDFDCCCCD4D4" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="13" Mark="*" Name="2nd Yellow Rev. (mm/dd/yy)" PageColor="#FDFDFFFFABAB" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="14" Mark="*" Name="2nd Green Rev. (mm/dd/yy)" PageColor="#D1D1FEFED0D0" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="15" Mark="*" Name="2nd Goldenrod Rev. (mm/dd/yy)" PageColor="#FAFACDCD3939" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="16" Mark="*" Name="2nd Buff Rev. (mm/dd/yy)" PageColor="#FCFCEDED9D9D" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="17" Mark="*" Name="2nd Salmon Rev. (mm/dd/yy)" PageColor="#F8F8AEAE8E8E" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="18" Mark="*" Name="2nd Cherry Rev. (mm/dd/yy)" PageColor="#FBFBA4A4B4B4" Style=""/>
      <Revision Color="#000000000000" FullRevision="No" ID="19" Mark="*" Name="2nd Tan Rev. (mm/dd/yy)" PageColor="#FDFDF1F1C7C7" Style=""/>
    </Revisions>`)

  xml.push('  <LockedPages/>')

  xml.push(`  <MoresAndContinueds>
      <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
      <DialogueBreaks AutomaticCharacterContinueds="Yes" BottomOfPage="Yes" DialogueBottom="(MORE)" DialogueTop="(CONT'D)" TopOfNext="Yes"/>
      <SceneBreaks ContinuedNumber="No" SceneBottom="(CONTINUED)" SceneBottomOfPage="No" SceneTop="CONTINUED:" SceneTopOfNext="No"/>
    </MoresAndContinueds>`)

  xml.push(`<SmartType>
      <Characters>
        ${createSmartTypeTag(script, 'Character', mode)}
      </Characters>
      <Extensions>
        ${createSmartTypeTag(script, 'Extension', mode)}
      </Extensions>
      <SceneIntros Separator=". ">
        <SceneIntro>INT</SceneIntro>
        <SceneIntro>EXT</SceneIntro>
        <SceneIntro>I/E</SceneIntro>
      </SceneIntros>
      <Locations>
      ${createSmartTypeTag(script, 'Location', mode)}
      </Locations>
      <TimesOfDay Separator=" - ">
        ${createSmartTypeTag(script, 'TimeOfDay', mode)}
      </TimesOfDay>
      <Transitions>
        ${createSmartTypeTag(script, 'Transition', mode)}
      </Transitions>
    </SmartType>`)

  xml.push('  <UnanchoredScriptNotes/>')

  xml.push(`<TitlePage>
      <HeaderAndFooter FooterFirstPage="Yes" FooterVisible="No" HeaderFirstPage="No" HeaderVisible="Yes" StartingPage="1">
        <Header>
          <Paragraph Alignment="Right" FirstIndent="0.00" Leading="Regular" LeftIndent="1.25" RightIndent="-1.25" SpaceBefore="0" Spacing="1" StartsNewPage="No">
            <DynamicLabel Type="Page #"/>
            <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="">.</Text>
          </Paragraph>
        </Header>
        <Footer>
          <Paragraph Alignment="Right" FirstIndent="0.00" Leading="Regular" LeftIndent="1.25" RightIndent="-1.25" SpaceBefore="0" Spacing="1" StartsNewPage="No">
            <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
          </Paragraph>
        </Footer>
      </HeaderAndFooter>
      <Content>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="Underline+AllCaps">Script Title</Text>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="">Written by</Text>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="">Name of First Writer</Text>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="">Based on, If Any</Text>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Center" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Full" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Full" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Full" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Full" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Full" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Full" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Full" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Full" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
        </Paragraph>
        <Paragraph Alignment="Full" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="">Address</Text>
        </Paragraph>
        <Paragraph Alignment="Full" FirstIndent="0.00" Leading="Regular" LeftIndent="1.00" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="">Phone Number</Text>
        </Paragraph>
      </Content>
      <TextState Scaling="100" Selection="0,0" ShowInvisibles="No"/>
    </TitlePage>`)

  xml.push(`  <ElementSettings Type="General">
      <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
      <ParagraphSpec Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.50" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No"/>
      <Behavior PaginateAs="General" ReturnKey="General" Shortcut="0"/>
    </ElementSettings>
    <ElementSettings Type="Scene Heading">
    <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="AllCaps"/>
    <ParagraphSpec Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.50" RightIndent="7.50" SpaceBefore="24" Spacing="1" StartsNewPage="No"/>
    <Behavior PaginateAs="Scene Heading" ReturnKey="Action" Shortcut="1"/>
  </ElementSettings>

  <ElementSettings Type="Action">
    <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
    <ParagraphSpec Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.50" RightIndent="7.50" SpaceBefore="12" Spacing="1" StartsNewPage="No"/>
    <Behavior PaginateAs="Action" ReturnKey="Action" Shortcut="2"/>
  </ElementSettings>

  <ElementSettings Type="Character">
    <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="AllCaps"/>
    <ParagraphSpec Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="3.50" RightIndent="7.25" SpaceBefore="12" Spacing="1" StartsNewPage="No"/>
    <Behavior PaginateAs="Character" ReturnKey="Dialogue" Shortcut="3"/>
  </ElementSettings>

  <ElementSettings Type="Parenthetical">
    <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
    <ParagraphSpec Alignment="Left" FirstIndent="-0.10" Leading="Regular" LeftIndent="3.00" RightIndent="5.50" SpaceBefore="0" Spacing="1" StartsNewPage="No"/>
    <Behavior PaginateAs="Parenthetical" ReturnKey="Dialogue" Shortcut="4"/>
  </ElementSettings>

  <ElementSettings Type="Dialogue">
    <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""/>
    <ParagraphSpec Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="2.50" RightIndent="6.00" SpaceBefore="0" Spacing="1" StartsNewPage="No"/>
    <Behavior PaginateAs="Dialogue" ReturnKey="Action" Shortcut="5"/>
  </ElementSettings>

  <ElementSettings Type="Transition">
    <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="AllCaps"/>
    <ParagraphSpec Alignment="Right" FirstIndent="0.00" Leading="Regular" LeftIndent="5.50" RightIndent="7.10" SpaceBefore="12" Spacing="1" StartsNewPage="No"/>
    <Behavior PaginateAs="Transition" ReturnKey="Scene Heading" Shortcut="6"/>
  </ElementSettings>

  <ElementSettings Type="Shot">
    <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="AllCaps"/>
    <ParagraphSpec Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.50" RightIndent="7.50" SpaceBefore="24" Spacing="1" StartsNewPage="No"/>
    <Behavior PaginateAs="Scene Heading" ReturnKey="Action" Shortcut="7"/>
  </ElementSettings>

  <ElementSettings Type="Cast List">
    <FontSpec AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="AllCaps"/>
    <ParagraphSpec Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.50" RightIndent="7.50" SpaceBefore="0" Spacing="1" StartsNewPage="No"/>
    <Behavior PaginateAs="Action" ReturnKey="Action" Shortcut="8"/>
  </ElementSettings>`)

  // is this how we make the font bigger?
  xml.push('  <WindowState Height="635" Left="12" Mode="Normal" Top="142" Width="1032"/><TextState Scaling="125" Selection="1777,1777" ShowInvisibles="No"/>')

  xml.push(`  <PageLayout BackgroundColor="#FFFFFFFFFFFF" BottomMargin="72" BreakDialogueAndActionAtSentences="Yes" DocumentLeading="Normal" FooterMargin="36" ForegroundColor="#000000000000" HeaderMargin="36" InvisiblesColor="#808080808080" TopMargin="72" UsesSmartQuotes="Yes">
      <PageSize Height="11.00" Width="8.50"/>
      <AutoCastList AddParentheses="Yes" AutomaticallyGenerate="Yes" CastListElement="Cast List"/>
    </PageLayout>`)

  xml.push(`  <SpellCheckIgnoreLists>
      <IgnoredRanges/>
      <IgnoredWords/>
    </SpellCheckIgnoreLists>`)

  /* eslint-disable no-tabs */
  xml.push(`  <HeaderAndFooter FooterFirstPage="Yes" FooterVisible="No" HeaderFirstPage="No" HeaderVisible="Yes" StartingPage="1">
      <Header>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="1.25" RightIndent="-1.00" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="">	</Text>
          <DynamicLabel Type="Last Revised"/>
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="">	</Text>
          <DynamicLabel Type="Page #"/>
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style="">.</Text>
          <Tabstops>
            <Tabstop Position="4.50" Type="Center"/>
            <Tabstop Position="7.25" Type="Right"/>
          </Tabstops>
        </Paragraph>
      </Header>
      <Footer>
        <Paragraph Alignment="Right" FirstIndent="0.00" Leading="Regular" LeftIndent="1.25" RightIndent="-1.25" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""> </Text>
        </Paragraph>
      </Footer>
    </HeaderAndFooter>`)
  /* eslint-enable no-tabs */

  xml.push(`  <Watermarking Opacity="70" Position="Diagonal Descending">
      <DynamicContent>
        <Paragraph Alignment="Left" FirstIndent="0.00" Leading="Regular" LeftIndent="0.00" RightIndent="1.39" SpaceBefore="0" Spacing="1" StartsNewPage="No">
          <Text AdornmentStyle="0" Background="#FFFFFFFFFFFF" Color="#000000000000" Font="Courier Final Draft" RevisionID="0" Size="12" Style=""></Text>
        </Paragraph>
      </DynamicContent>
      <Distribution>
        <Name></Name>
      </Distribution>
      <WatermarkImage Height="144"></WatermarkImage>
    </Watermarking>`)

  // content parsed below VVV script metadata above ^^^
  xml.push('</Content>')

  return { xml, script }
}

module.exports = xmlBoilerplate
